import { customizationsAPI } from '../../api/customizationsAPI';

export const OFFERING_VERTICALS = {
  boutique: {
    kind: 'boutique',
    label: 'boutique',
    labelPlural: 'boutiques',
    titleCase: 'Boutique',
    titleCasePlural: 'Boutiques',
    browseBackPath: '/boutiques',
    introPath: '/custom-order',
    pickerPath: '/custom-order/boutiques',
    shopOfferingsPath: (shopId) => `/custom-order/boutiques/${shopId}`,
    wizardPath: (requestId, step) => `/custom-order/${requestId}/step/${step}`,
    ownerInboxPath: '/boutique/customization-requests',
    ownerDetailPath: (requestId) => `/boutique/customization-requests/${requestId}`,
    ownerQuotePath: (requestId) => `/boutique/customization-requests/${requestId}/quote`,
    ownerSettingsPath: '/boutique/customization-settings',
    listShops: (params) => customizationsAPI.listCustomBoutiques(params),
    listOfferingsPublic: (shopId) => customizationsAPI.listBoutiqueOfferingsPublic(shopId),
    createDraft: (payload) => customizationsAPI.createBoutiqueDraft(payload),
    getSettings: () => customizationsAPI.getBoutiqueSettings(),
    updateSettings: (payload) => customizationsAPI.updateBoutiqueSettings(payload),
    listOfferings: () => customizationsAPI.listBoutiqueOfferings(),
    createOffering: (payload) => customizationsAPI.createBoutiqueOffering(payload),
    updateOffering: (id, payload) => customizationsAPI.updateBoutiqueOffering(id, payload),
    deleteOffering: (id) => customizationsAPI.deleteBoutiqueOffering(id),
    getInbox: () => customizationsAPI.getBoutiqueInbox(),
    getRequest: (id) => customizationsAPI.getBoutiqueRequest(id),
    declineRequest: (id) => customizationsAPI.declineBoutiqueRequest(id),
    sendQuote: (id, payload) => customizationsAPI.sendBoutiqueQuote(id, payload),
  },
  designer: {
    kind: 'designer',
    label: 'designer',
    labelPlural: 'designers',
    titleCase: 'Designer',
    titleCasePlural: 'Designers',
    browseBackPath: '/designers',
    introPath: '/custom-order/designers/start',
    pickerPath: '/custom-order/designers',
    shopOfferingsPath: (shopId) => `/custom-order/designers/${shopId}`,
    wizardPath: (requestId, step) => `/custom-order/designer/${requestId}/step/${step}`,
    ownerInboxPath: '/designer/customization-requests',
    ownerDetailPath: (requestId) => `/designer/customization-requests/${requestId}`,
    ownerQuotePath: (requestId) => `/designer/customization-requests/${requestId}/quote`,
    ownerSettingsPath: '/designer/customization-settings',
    listShops: (params) => customizationsAPI.listCustomDesigners(params),
    listOfferingsPublic: (shopId) => customizationsAPI.listDesignerOfferingsPublic(shopId),
    createDraft: (payload) => customizationsAPI.createDesignerDraft(payload),
    getSettings: () => customizationsAPI.getDesignerSettings(),
    updateSettings: (payload) => customizationsAPI.updateDesignerSettings(payload),
    listOfferings: () => customizationsAPI.listDesignerOfferings(),
    createOffering: (payload) => customizationsAPI.createDesignerOffering(payload),
    updateOffering: (id, payload) => customizationsAPI.updateDesignerOffering(id, payload),
    deleteOffering: (id) => customizationsAPI.deleteDesignerOffering(id),
    getInbox: () => customizationsAPI.getDesignerInbox(),
    getRequest: (id) => customizationsAPI.getDesignerRequest(id),
    declineRequest: (id) => customizationsAPI.declineDesignerRequest(id),
    sendQuote: (id, payload) => customizationsAPI.sendDesignerQuote(id, payload),
  },
};

export const getOfferingVertical = (key = 'boutique') =>
  OFFERING_VERTICALS[key] || OFFERING_VERTICALS.boutique;
